var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import RootCloseWrapper from 'react-overlays/lib/RootCloseWrapper';
import { defineMessages, useIntl } from 'react-intl';
import CheckboxMenu from './CheckboxMenu';
const messages = defineMessages({
    SearchFilters: {
        id: 'SearchFilters',
        defaultMessage: 'Search filters',
    },
});
const isSelectAllItem = (id) => id.toLowerCase() === 'selectall';
const CheckboxDropdownMenu = React.forwardRef((_a, ref) => {
    var { open, onClose, rootCloseEvent, bsRole, items, onItemChanged } = _a, rest = __rest(_a, ["open", "onClose", "rootCloseEvent", "bsRole", "items", "onItemChanged"]);
    const { formatMessage } = useIntl();
    const [searchText, setSearchText] = useState('');
    const searchInputRef = useRef(null);
    useEffect(() => {
        if (!open) {
            setSearchText('');
        }
    }, [open]);
    useEffect(() => {
        if (open && searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [open]);
    const selectAllItem = useMemo(() => items.find(item => isSelectAllItem(item.id)), [items]);
    const regularItems = useMemo(() => items.filter(item => !isSelectAllItem(item.id)), [items]);
    const filteredItems = useMemo(() => {
        if (!searchText.trim())
            return items;
        const search = searchText.trim().toLowerCase();
        const matched = regularItems.filter(item => item.label.toLowerCase().includes(search));
        if (!selectAllItem)
            return matched;
        // When searching, derive selectAll state from whether all visible items are selected
        const allVisibleSelected = matched.length > 0 && matched.every(i => i.selected);
        return [Object.assign(Object.assign({}, selectAllItem), { selected: allVisibleSelected }), ...matched];
    }, [items, regularItems, selectAllItem, searchText]);
    const handleItemChanged = (item, selected) => {
        if (isSelectAllItem(item.id) && searchText.trim()) {
            const visibleIds = filteredItems.filter(i => !isSelectAllItem(i.id)).map(i => i.id);
            onItemChanged(item, selected, visibleIds);
        }
        else {
            onItemChanged(item, selected);
        }
    };
    return (_jsx(RootCloseWrapper, Object.assign({ disabled: !open, onRootClose: e => onClose(e, { source: 'rootClose' }), event: rootCloseEvent, ref: ref }, { children: _jsxs("div", Object.assign({ className: "dropdown-menu checkbox-dropdown-searchable" }, { children: [_jsx("div", Object.assign({ className: "checkbox-dropdown-search" }, { children: _jsx("input", { ref: searchInputRef, type: "text", value: searchText, onChange: e => setSearchText(e.target.value), placeholder: formatMessage(messages.SearchFilters), onClick: e => e.stopPropagation() }) })), _jsx("div", Object.assign({ className: "checkbox-dropdown-list" }, { children: _jsx(CheckboxMenu, Object.assign({}, rest, { items: filteredItems, onItemChanged: handleItemChanged })) }))] })) })));
});
export default CheckboxDropdownMenu;
